import React from 'react';
import styled from 'styled-components';
import { Zocdoc, Lock } from '@zocdoc-frontend-common/assets-icons';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

const SecureBookingByZocdoc = () => {
    return (
        <SecureBookingByZocdocContainer data-test="secure-booking-by-zocdoc">
            <SecureBookingByZocdocLock color="currentColor" />
            Secure booking by <Zocdoc color="currentColor" />
        </SecureBookingByZocdocContainer>
    );
};

const SecureBookingByZocdocContainer = styled.div`
    display: none;
    margin-top: 16px;
    font: 15px/1 ${FontFamily.SharpSansSemibold};

    ${breakpoint.small} {
        display: inherit;
    }
`;

const SecureBookingByZocdocLock = styled(Lock)`
    font-size: 20px;
    transform: translateY(20%);
    margin-right: 13px;
`;

export default SecureBookingByZocdoc;
